"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlFromEL = void 0;
const text_1 = require("./text");
const parentheses_1 = require("./parentheses");
const declaration_1 = require("./declaration");
const varRef_1 = require("./varRef");
const pointer_1 = require("./pointer");
const lawNum_1 = require("./lawNum");
const lawRef_1 = require("./lawRef");
__exportStar(require("./text"), exports);
__exportStar(require("./parentheses"), exports);
__exportStar(require("./varRef"), exports);
__exportStar(require("./declaration"), exports);
__exportStar(require("./pointer"), exports);
__exportStar(require("./lawNum"), exports);
__exportStar(require("./lawRef"), exports);
const controlFromEL = (el) => {
    if (el.tag === "__Text") {
        return Object.setPrototypeOf(el.copy(false, true), text_1.__Text.prototype);
    }
    else if (el.tag === "__Parentheses") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__Parentheses.prototype);
    }
    else if (el.tag === "__PStart") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__PStart.prototype);
    }
    else if (el.tag === "__PContent") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__PContent.prototype);
    }
    else if (el.tag === "__PEnd") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__PEnd.prototype);
    }
    else if (el.tag === "__MismatchStartParenthesis") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__MismatchStartParenthesis.prototype);
    }
    else if (el.tag === "__MismatchEndParenthesis") {
        return Object.setPrototypeOf(el.copy(false, true), parentheses_1.__MismatchEndParenthesis.prototype);
    }
    else if (el.tag === "____Declaration") {
        return Object.setPrototypeOf(el.copy(false, true), declaration_1.____Declaration.prototype);
    }
    else if (el.tag === "____VarRef") {
        return Object.setPrototypeOf(el.copy(false, true), varRef_1.____VarRef.prototype);
    }
    else if (el.tag === "____PointerRanges") {
        return Object.setPrototypeOf(el.copy(false, true), pointer_1.____PointerRanges.prototype);
    }
    else if (el.tag === "____PointerRange") {
        return Object.setPrototypeOf(el.copy(false, true), pointer_1.____PointerRange.prototype);
    }
    else if (el.tag === "____Pointer") {
        return Object.setPrototypeOf(el.copy(false, true), pointer_1.____Pointer.prototype);
    }
    else if (el.tag === "____PF") {
        return Object.setPrototypeOf(el.copy(false, true), pointer_1.____PF.prototype);
    }
    else if (el.tag === "____LawNum") {
        return Object.setPrototypeOf(el.copy(false, true), lawNum_1.____LawNum.prototype);
    }
    else if (el.tag === "____LawRef") {
        return Object.setPrototypeOf(el.copy(false, true), lawRef_1.____LawRef.prototype);
    }
    else {
        return el;
    }
};
exports.controlFromEL = controlFromEL;
//# sourceMappingURL=index.js.map